import React from 'react';
import { Card } from 'reactstrap';
import { H2, H3, H6, P, UL, LI, Btn } from '../../../AbstractElements';
import { Subscribe } from '../../../Constant';

const PricingDetail = ({ data }) => {
  return (
    <Card className='pricing-block text-center '>
      <div className='pricing-header'>
        <H2>{data.type}</H2>
        <div className='price-box'>
          <div>
            <H3>${data.price}</H3>
            <P>/ {data.duration}</P>
          </div>
        </div>
      </div>
      <div className='pricing-list'>
        <UL className='pricing-inner'>
          {data.benefit &&
            data.benefit.map((item, i) => (
              <LI className='bg-transparent' key={i}>
                <H6>
                  {item.beni}
                  {item.unit && item.unit}
                  <span> {item.title}</span>
                </H6>
              </LI>
            ))}
        </UL>
        <Btn color='primary' className='btn btn-lg' type='button'>
          {Subscribe}
        </Btn>
      </div>
    </Card>
  );
};

export default PricingDetail;
